module.exports = __webpack_public_path__ + "img/4.9e4a3e32.png";